module.exports = __webpack_public_path__ + "versions.png?f39e4bd0cdd171341a6bd84f625ff208";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global/img/versions.png
// module id = 24
// module chunks = 0